module.exports = __webpack_public_path__ + "static/media/singleTix.78c3ce01.png";